import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import AppErrorBoundary from './components/AppErrorBoundary/AppErrorBoundary';
import { scrubSensitiveQueryParams } from './utils/sensitiveUrl';

// Move verification / reset tokens out of the address bar BEFORE anything else
// (analytics, session replay) can observe the URL.
scrubSensitiveQueryParams();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <AppErrorBoundary>
            <HelmetProvider>
                <App />
            </HelmetProvider>
        </AppErrorBoundary>
    </React.StrictMode>
);

reportWebVitals();